<arm-layout>
    <div header>
        <div class="search-container">
            <arm-search [searchComponent]="voipPeersSearchComponent"
                        [searchData]="searchData"
                        [searchTerms]="searchTerms"
                        (onSearch)="onSearch($event)">
            </arm-search>
        </div>

        <div class="action-buttons">
            <arm-action-bar (editClick)="editItem()" [disableEdit]="isUnauthorized || !this.isSingleSelection()"
                            (deleteClick)="removeItem()" [disableDelete]="isUnauthorized || !this.isAnySelection() || !isVPNotLonely()"
                            (refreshClick)="refresh()"></arm-action-bar>

            <button mat-raised-button class="more-actions" [matMenuTriggerFor]="menu" color="primary">
                <span>Actions</span>
                <mat-icon>arrow_drop_down</mat-icon>
            </button>

            <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="openColumnsConfiguration()">
                    <span>Table columns</span>
                </button>
            </mat-menu>
        </div>
    </div>

    <div main>
      <arm-table  [displayedColumns]="displayedColumns" (pageChanged)="pageChanged($event)"
                 (onSelection)="onSelection($event)" [data]="data.elements" [length]="data.totalElements"
                 [isMultipleSelection]="isMultipleSelection"
                 [isClientSide]="false"></arm-table>
    </div>
</arm-layout>
